export default "__VITE_ASSET__BfapLATX__"